// 日志管理
import http from "@/jslibs/axios/http";

// 日志分页列表
export const page = (data) => http.post("/web/permissionManager/getSysLogList", data);
